export default {
	deviceList: {
		title: 'Lista de Dispositivos',
		total: 'Total de Dispositivos',
		running: 'En Funcionamiento',
		stopped: 'Detenido',
		offline: 'Fuera de Línea',
		lowAlarm: 'Alarma Leve',
		mediumAlarm: 'Alarma Media',
		severeAlarm: 'Alarma Severa',
		unit: 'unidades',
		noData: 'Sin Datos',
		deviceName: 'Nombre del Dispositivo',
		status: {
			running: 'En Funcionamiento',
			stopped: 'Detenido',
			offline: 'Fuera de Línea'
		},
		warnLevel: {
			normal: 'Normal',
			low: 'Leve',
			medium: 'Medio',
			severe: 'Severo'
		},
		labels: {
			warnLevel: 'Nivel de Alarma',
			runDuration: 'Duración de Funcionamiento Actual',
			stopDuration: 'Duración de Parada Actual',
			offlineDuration: 'Duración Fuera de Línea',
			deviceType: 'Tipo de Dispositivo'
		},
		imageError: 'Error al Cargar Imagen',
		filter: {
			total: 'total',
			status: {
				running: 'RUN',
				stopped: 'STOP',
				offline: 'OFFLINE'
			}
		},
		sensorGroup: 'Grupo de Sensores',
		configDeviceModel: 'Configurar Modelo de Dispositivo',
		sensorManager: 'Sensores',
		selectAll: 'Seleccionar',
		clearAll: 'Limpiar',
		maxSensorsTip: 'Máximo 20 sensores mostrados',
		editGroup: 'Editar Grupo',
		addGroup: 'Añadir Grupo',
		groupName: 'Nombre del Grupo',
		groupNameRequired: 'Por favor ingrese el nombre del grupo',
		groupNamePlaceholder: 'Por favor ingrese el nombre del grupo',
		selectSensor: 'Seleccionar Sensor',
		searchSensor: 'Buscar Sensor',
		noOptionalSensors: 'No hay sensores disponibles',
		onlineStatus: 'En línea',
		offlineStatus: 'Fuera de línea',
		alarmInfoSuffix: 'Información de Alarma',
		messages: {
			updateSuccess: 'Actualizado correctamente',
			updateFailed: 'Error al actualizar',
			addSuccess: 'Añadido correctamente',
			addFailed: 'Error al añadir',
			deleteSuccess: 'Eliminado correctamente',
			deleteFailed: 'Error al eliminar',
			save3DSuccess: 'Posición 3D guardada correctamente',
			save3DEmpty: 'No hay datos de posición 3D para guardar',
			savePointSuccess: 'Posición guardada correctamente',
			set3DModelSuccess: 'Modelo 3D del dispositivo configurado correctamente',
			set25DSuccess: 'Imagen 2.5D del dispositivo configurada correctamente',
			groupNameRequired: 'Por favor ingrese el nombre del grupo',
			sensorRequired: 'Por favor seleccione al menos un sensor',
			deleteGroupConfirm: '¿Confirmar eliminar este grupo? Los sensores del grupo quedarán sin grupo.',
			deleteGroupSimpleConfirm: '¿Confirmar eliminar este grupo?',
			confirmTitle: 'Aviso',
			confirm: 'Confirmar',
			cancel: 'Cancelar'
		},
		warnStatusText: {
			normal: 'Normal',
			general: 'General',
			medium: 'Medio',
			severe: 'Severo'
		}
	},
	deviceDetails: {
		back: 'Volver',
		featureUpdateTime: 'Tiempo de Actualización de Datos',
		deviceParams: 'Parámetros del Dispositivo',
		deviceInfo: 'Información del Dispositivo',
		deviceNumber: 'Número de Dispositivo',
		deviceNameLabel: 'Nombre del Dispositivo',
		type: 'Tipo',
		orgName: 'Fábrica',
		healthDegree: 'Salud del Dispositivo',
		alertStats: 'Estadísticas de Alarma',
		totalWarnings: 'Total de Alarmas',
		critical: 'Crítico',
		medium: 'Medio',
		normal: 'Normal',
		runOverview: 'Resumen de Operación',
		startStopRecord: 'Registro de Inicio/Parada',
		operationRate: 'Tasa de Operación',
		totalRunDuration: 'Duración Total de Funcionamiento',
		totalOnlineDuration: 'Tiempo Total en Línea',
		hour: 'horas',
		deviceStatus: 'Estado del Dispositivo',
		diagnosticReport: 'Informe de Diagnóstico',
		noDiagnosticReport: 'Sin Informe de Diagnóstico',
		alarmProcessing: 'Procesamiento de Alarma',
		startStopTitle: 'Registro de Inicio/Parada',
		status: {
			running: 'En Funcionamiento',
			stopped: 'Detenido',
			offline: 'Fuera de Línea'
		},
		healthStatus: {
			good: 'Buen Estado de Salud',
			medium: 'Estado de Salud Regular',
			poor: 'Mal Estado de Salud'
		},
		healthTip: {
			good: 'Dispositivo funcionando bien, se recomienda inspección regular',
			medium: 'Se recomienda fortalecer el monitoreo y mantenimiento',
			poor: 'Se necesita revisión del equipo para prevenir fallos'
		},
		alertLevel: {
			healthy: 'Equipo Saludable',
			low: 'Alarma Leve',
			medium: 'Alarma Media',
			severe: 'Alarma Severa',
			unknown: 'Estado Desconocido'
		},
		alertDesc: {
			low: 'Anomalía menor detectada, por favor monitorear de cerca',
                        medium: 'Anomalía moderada detectada, se recomienda atenderla a tiempo',
			severe: 'Anomalía severa detectada, se requiere acción inmediata',
			unknown: 'Estado del equipo desconocido'
		},
		suggestion: 'Se sugiere monitorear la operación',
		alarmBtn: 'Procesamiento de Alarma',
		duration: 'Duración de la Alarma',
		currentDuration: {
			running: 'Duración de Funcionamiento Actual',
			stopped: 'Duración de Parada',
			offline: 'Duración Fuera de Línea',
			default: 'Duración del Estado'
		},
		offlineTotalDuration: 'Duración Total de Funcionamiento (Antes de Desconexión)'
	},
	digitalTwin: {
		title: 'Gemelo Digital de Dispositivos',
		digitalModeling: 'Modelado Digital',
		realtimeMonitoring: 'Monitoreo en Tiempo Real',
		monitoringPlaceholder: 'Video de monitoreo en sitio en proceso de conexión, próximamente',
		deviceSelectTip: 'Por favor seleccione un dispositivo',
		noDevice: 'Sin datos de dispositivos',
		modelLoading: 'Cargando modelo...',
		modelLoadFailed: 'Error al cargar el modelo',
		electrical: {
			title: 'Parámetros Eléctricos',
			inverterParams: 'Parámetros de Funcionamiento del Inversor',
			weightInfo: 'Información de Peso',
			deviceStatusWord: 'Palabra de Estado del Dispositivo',
			ioStatus: 'Estado de E/S del Dispositivo',
			faultInfo: 'Información de Fallos del Sistema',
			faultCode: 'Código de Fallo',
			normal: 'Normal',
			fault: 'Fallo',
			bit: 'Bit',
			updateTime: 'Hora de Actualización de Datos',
			mechanism: {
				bridge: 'Puente',
				trolley: 'Carro',
				hoist: 'Izaje',
				grab: 'Cucharón'
			},
			params: {
				outputVoltage: 'Voltaje de Salida',
				outputCurrent: 'Corriente de Salida',
				outputTorque: 'Par de Salida',
				outputSpeed: 'Velocidad de Salida',
				dcBusVoltage: 'Voltaje del Bus DC',
				actualPosition: 'Posición Actual'
			},
			weight: {
				hoist: 'Peso de Izaje',
				grab: 'Peso del Cucharón',
				total: 'Peso Total'
			}
		}
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula',
		deviceName: 'Nombre del Dispositivo',
		deviceNumber: 'Número de Dispositivo',
		projectNumber: 'Número de Proyecto',
		status: 'Estado',
		deviceType: 'Tipo de Dispositivo',
		org: 'Organización',
		deviceImage: 'Imagen del Dispositivo',
		deviceModelImage: 'Imagen del Modelo del Dispositivo',
		sort: 'Ordenar',
		placeholder: {
			org: 'Organización (Diagnóstico)'
		},
		rules: {
			required: 'El campo obligatorio no puede estar vacío'
		},
		labels: {
			label1: 'Etiqueta 1'
		}
	},
	deviceModelLibrary: {
		configDeviceModel: 'Configurar Modelo de Dispositivo',
		selectDeviceType: 'Seleccionar Tipo de Dispositivo',
		deviceModelImageAlt: 'Imagen del Modelo del Dispositivo',
		addModelImage: 'Añadir Imagen del Modelo',
		messages: {
			pleaseSelectModel: 'Por favor seleccione una imagen de modelo de dispositivo',
			deleteConfirm: '¿Está seguro de que desea eliminar este modelo?',
			deleteConfirmTitle: 'Aviso',
			deleteConfirmBtn: 'Confirmar',
			deleteCancelBtn: 'Cancelar',
			deleteSuccess: 'Eliminado correctamente',
			operationSuccess: 'Operación exitosa'
		}
	},
	devicePlm: {
		deviceBasicInfo: 'Información Básica del Dispositivo',
		editDeviceBasicInfo: 'Editar Información Básica del Dispositivo',
		fieldName: 'Nombre',
		fieldValue: 'Valor',
		fieldNamePlaceholder: 'Nombre',
		fieldValuePlaceholder: 'Valor',
		healthHistory: 'Historial de Salud',
		date: 'Fecha',
		healthScore: 'Puntuación de Salud',
		messages: {
			updateSuccess: 'Información del dispositivo actualizada correctamente',
			updateFailed: 'Error al actualizar la información del dispositivo'
		},
		status: {
			normal: 'Normal',
			abnormal: 'Anormal',
			warning: 'Advertencia',
			maintenance: 'En Mantenimiento'
		}
	}
}
